import { render, staticRenderFns } from "./CatalogSection.vue?vue&type=template&id=3c32ed2c&"
import script from "./CatalogSection.vue?vue&type=script&lang=js&"
export * from "./CatalogSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports